import React from 'react';
import { withStyles, WithStyles, createStyles, ButtonBase, Button } from '@material-ui/core';
import { withConfig, Theme } from '../../../config/';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { imagePath } from '../../../utilities/';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import UndoIcon from '@material-ui/icons/Undo';
import ConfirmActionButton from 'components/UI/ConfirmActionButton';
import { useLanguage } from 'languages/languageContext';

const defaultUser = require('../../../assets/default_avatar.png');

const styles = createStyles({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px 20px',
  },
  leftContent: {
    display: 'flex',
    alignItems: 'flex-start',
    flexGrow: 1,
    textAlign: 'left',
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 60,
    height: 60,
    marginRight: 10,
    borderRadius: 30,
    border: '1px solid',
    overflow: 'hidden',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  content: {
    marginLeft: 10,
  },
  name: {
    display: 'block',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 18,
    textAlign: 'left',
  },
  desc: {
    display: 'block',
    fontFamily: 'Roboto',
    fontSize: 14,
    textAlign: 'left',
  },
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
  },
  '@media(max-width: 650px)': {
    name: {
      maxWidth: 200,
    },
  },
  iconButton: {
    minWidth: 40,
    height: 40,
    width: 40,
    padding: 8,
    borderRadius: '50%',
  },
});

interface Props extends WithStyles<typeof styles>, RouteComponentProps<any> {
  theme: Theme;
  user: any;
  onClick: () => void;
  type?: 'incoming' | 'outgoing';
  onAccept?: () => void;
  onDecline?: () => void;
}

const RequestItem: React.FC<Props> = ({ classes, theme, user, onClick, type, onAccept, onDecline }) => {
  const { mentoring } = useLanguage();

  let image = imagePath(null, user.photo);

  const fullName = `${user.name} ${user.lastname}`;

  return (
    <div className={classes.container}>
      <ButtonBase onClick={onClick} style={{ flexGrow: 1, textAlign: 'left' }}>
        <div className={classes.leftContent}>
          <div className={classes.imageWrapper} style={{ borderColor: theme.ICON_BORDER }}>
            <img src={image || defaultUser} alt=" " style={{ width: '100%' }} />
          </div>
          <div className={classes.content}>
            <span className={classes.name} style={{ color: theme.TEXT_PRIMARY }}>
              {user.name} {user.lastname}
            </span>
            <span className={classes.desc} style={{ color: theme.TEXT_SECONDARY }}>
              {user.wohnort}
            </span>
            <span className={classes.desc} style={{ color: theme.TEXT_SECONDARY }}>
              {user.corp[0] && user.corp[0].corpsname}
            </span>
          </div>
        </div>
      </ButtonBase>
      <div className={classes.actionButtons}>
        {type === 'incoming' && (
          <>
            <Button
              variant="contained"
              className={classes.iconButton}
              style={{ backgroundColor: '#4caf50', marginRight: 12 }}
              onClick={onAccept}
            >
              <CheckIcon style={{ color: '#fff' }} />
            </Button>
            <ConfirmActionButton
              icon={
                <Button variant="contained" className={classes.iconButton} style={{ backgroundColor: '#f44336' }}>
                  <CloseIcon style={{ color: '#fff' }} />
                </Button>
              }
              dialogTitle={mentoring.requests.rejectPopupTitle}
              dialogText={mentoring.requests.rejectPopupText(fullName)}
              confirmLabel={mentoring.requests.confirm}
              cancelLabel={mentoring.requests.cancel}
              onConfirm={onDecline}
            />
          </>
        )}
        {type === 'outgoing' && (
          <ConfirmActionButton
            icon={
              <Button
                variant="contained"
                className={classes.iconButton}
                style={{ backgroundColor: theme.BUTTON_PRIMARY }}
              >
                <UndoIcon style={{ color: '#fff' }} />
              </Button>
            }
            dialogTitle={mentoring.requests.withdrawTitle}
            dialogText={mentoring.requests.withdrawText(fullName)}
            confirmLabel={mentoring.requests.confirm}
            cancelLabel={mentoring.requests.cancel}
            onConfirm={onDecline}
          />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(withRouter(withConfig(RequestItem)));
